import { useSyncExternalStore } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '@/components/atoms/Button/Button';
import AiSearchComposer from '@/Pages/Sessions/RecentEvents/AiClips/AiSearchComposer';
import { FeatureFlagKeys } from '@/services/featureFlag';
import featureFlagStore from '@/stores/featureFlagStore';

export default function HomeHeader() {
  const navigate = useNavigate();
  const featureFlags = useSyncExternalStore(featureFlagStore.subscribe, featureFlagStore.getSnapshot);
  const hideLegacyBrandKitButton = !!featureFlags[FeatureFlagKeys.Use_CL_Platform_Brandkit];

  const handleManageBrandKit = () => {
    navigate('/brand-kit');
  };

  return (
    <div className="pr-4">
      <div className="mb-8 flex items-center justify-between">
        <div className="text-3xl font-medium text-slate-950">Content Lab</div>
        {!hideLegacyBrandKitButton && (
          <Button variation="outline" trackingId="brand-kit-button" buttonSize="small" onClick={handleManageBrandKit}>
            Manage Brand Kit
          </Button>
        )}
      </div>
      <AiSearchComposer />
    </div>
  );
}
